import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { FilingFields } from "@/features/filings/components/filing-fields"
import { FilingNotices } from "@/features/filings/components/filing-notices"
import { RecordFilingApprovalDialog } from "@/features/filings/components/record-filing-approval-dialog"
import { SubmitFilingDialog } from "@/features/filings/components/submit-filing-dialog"
import { filingQueries } from "@/queries/filings"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/filings/$filingId/"
)({
  component: FilingPage,
})

/** The FCA's form with our value beside each question, ready to type across. */
function FilingPage() {
  const { filingId } = Route.useParams()
  const { data: filing } = useSuspenseQuery(filingQueries.detail(filingId))

  return (
    <>
      <PageHeader
        title={filing.formLabel}
        actions={
          <>
            <SubmitFilingDialog filing={filing} />
            <RecordFilingApprovalDialog filing={filing} />
          </>
        }
      />
      <PageContent>
        <FilingNotices filing={filing} />
        <FilingFields groups={filing.groups} />
      </PageContent>
    </>
  )
}
